// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"549":"8f7f9fe4","781":"451bb840","984":"17451e46"}[chunkId] + ".chunk.js";
};